<div class="ci-wrapper">
  <!-- ══════════════════════════════════════════════════════════════════
         F I L T E R   B A R
    ══════════════════════════════════════════════════════════════════ -->
  <div *ngIf="false" class="ci-filter-bar">
    <!-- ── Company Multi-Select ─────────────────────────────────────── -->
    <div class="ci-filter-group">
      <label class="ci-filter-label">Company</label>
      <div class="ci-multiselect-host" #companyDropdownHost>
        <button
          type="button"
          class="ci-multiselect-trigger"
          [class.ci-multiselect-trigger--active]="pendingCompanies.length > 0"
          (click)="toggleCompanyDropdown()"
          [attr.aria-expanded]="companyDropdownOpen"
          aria-haspopup="listbox"
        >
          <span class="ci-multiselect-label">
            @if (pendingCompanies.length === 0) {
              All Companies
            } @else if (pendingCompanies.length === 1) {
              {{ pendingCompanies[0] }}
            } @else {
              {{ pendingCompanies.length }} companies selected
            }
          </span>
          <svg
            class="ci-chevron"
            [class.ci-chevron--open]="companyDropdownOpen"
            width="12"
            height="12"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2.5"
            aria-hidden="true"
          >
            <polyline points="6 9 12 15 18 9" />
          </svg>
        </button>

        @if (companyDropdownOpen) {
          <div
            class="ci-multiselect-panel"
            role="listbox"
            aria-multiselectable="true"
            aria-label="Select companies"
          >
            <div class="ci-multiselect-search">
              <svg
                width="12"
                height="12"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#8a96a8"
                stroke-width="2"
                aria-hidden="true"
              >
                <circle cx="11" cy="11" r="8" />
                <line x1="21" y1="21" x2="16.65" y2="16.65" />
              </svg>
              <input
                #companySearchInput
                type="text"
                class="ci-multiselect-search-input"
                placeholder="Search companies…"
                [value]="companySearchText()"
                (input)="onCompanySearch($event)"
                aria-label="Search companies"
                autocomplete="off"
              />
              @if (companySearchText()) {
                <button
                  type="button"
                  class="ci-search-clear"
                  (click)="clearCompanySearch()"
                  aria-label="Clear search"
                >
                  ✕
                </button>
              }
            </div>

            <div class="ci-multiselect-actions">
              <button
                type="button"
                class="ci-multiselect-action-btn"
                (click)="selectAllCompanies()"
              >
                Select All
              </button>
              <button
                type="button"
                class="ci-multiselect-action-btn"
                (click)="clearPendingCompanies()"
              >
                Clear
              </button>
            </div>

            <ul class="ci-multiselect-list">
              @if (filteredCompanyOptions().length === 0) {
                <li class="ci-multiselect-empty">No companies found</li>
              }
              @for (co of filteredCompanyOptions(); track co) {
                <li
                  class="ci-multiselect-option"
                  [class.ci-multiselect-option--selected]="
                    isPendingCompanySelected(co)
                  "
                  role="option"
                  [attr.aria-selected]="isPendingCompanySelected(co)"
                  (click)="togglePendingCompany(co)"
                >
                  <span
                    class="ci-checkbox"
                    [class.ci-checkbox--checked]="isPendingCompanySelected(co)"
                    aria-hidden="true"
                  >
                    @if (isPendingCompanySelected(co)) {
                      ✓
                    }
                  </span>
                  {{ co }}
                </li>
              }
            </ul>
          </div>
        }
      </div>
    </div>

    <!-- ── Status Filter ─────────────────────────────────────────────── -->
    <div class="ci-filter-group">
      <label class="ci-filter-label" for="ci-status-select">Status</label>
      <select
        id="ci-status-select"
        class="ci-select"
        [(ngModel)]="pendingStatus"
        aria-label="Filter by status"
      >
        <option value="">All Statuses</option>
        <option value="Sent">Sent</option>
        <option value="Failed">Failed</option>
        <option value="Pending">Pending</option>
      </select>
    </div>

    <!-- ── Category Type ─────────────────────────────────────────────── -->
    <div class="ci-filter-group">
      <label class="ci-filter-label" for="ci-category-select"
        >Category Type</label
      >
      <select
        id="ci-category-select"
        class="ci-select"
        [(ngModel)]="pendingCategoryType"
        aria-label="Filter by category type"
      >
        <option value="">All Categories</option>
        @for (cat of categoryTypes(); track cat) {
          <option [value]="cat">{{ cat }}</option>
        }
      </select>
    </div>

    <!-- ── Sent Date Range ───────────────────────────────────────────── -->
    <div class="ci-filter-group ci-filter-group--date">
      <label class="ci-filter-label">Sent Date</label>
      <div class="ci-date-range-host">
        <select
          class="ci-select ci-select--date-preset"
          [(ngModel)]="pendingDatePreset"
          (ngModelChange)="onDatePresetChange($event)"
          aria-label="Sent date preset"
        >
          <option value="all">All</option>
          <option value="">Custom Range</option>
          <option value="7">Last 7 Days</option>
          <option value="30">Last 30 Days</option>
          <option value="60">Last 60 Days</option>
        </select>

        @if (pendingDatePreset === "") {
          <div class="ci-date-inputs">
            <div class="ci-date-field">
              <span class="ci-date-field-label">From</span>
              <p-datepicker
                [(ngModel)]="pendingDateFromObj"
                [showIcon]="true"
                [showButtonBar]="true"
                dateFormat="mm/dd/yy"
                placeholder="MM/DD/YYYY"
                [showOnFocus]="true"
                [maxDate]="pendingDateToObj ?? undefined"
                inputId="ci-date-from"
                styleClass="ci-primeng-datepicker"
                inputStyleClass="ci-date-input"
                aria-label="Sent date from"
                appendTo="body"
              />
            </div>
            <span class="ci-date-sep">–</span>
            <div class="ci-date-field">
              <span class="ci-date-field-label">To</span>
              <p-datepicker
                [(ngModel)]="pendingDateToObj"
                [showIcon]="true"
                [showButtonBar]="true"
                dateFormat="mm/dd/yy"
                placeholder="MM/DD/YYYY"
                [showOnFocus]="true"
                [minDate]="pendingDateFromObj ?? undefined"
                inputId="ci-date-to"
                styleClass="ci-primeng-datepicker"
                inputStyleClass="ci-date-input"
                aria-label="Sent date to"
                appendTo="body"
              />
            </div>
          </div>
        }
      </div>
    </div>

    <!-- ── Action Buttons ────────────────────────────────────────────── -->
    <div class="ci-filter-actions">
      <button
        type="button"
        class="ci-btn-search"
        (click)="applyFilters()"
        [disabled]="loading()"
        aria-label="Apply filters"
      >
        <svg
          width="13"
          height="13"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2.5"
          stroke-linecap="round"
          stroke-linejoin="round"
          aria-hidden="true"
        >
          <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" />
        </svg>
        Filter
      </button>

      @if (hasAppliedFilters()) {
        <button type="button" class="ci-btn-reset" (click)="resetFilters()">
          Reset
        </button>
      }
    </div>
  </div>
  <!-- /filter-bar -->

  <!-- ── Applied Filter Chips ─────────────────────────────────────────── -->
  @if (hasAppliedFilters()) {
    <div class="ci-chips-bar" aria-label="Active filters">
      @if (appliedCompanies.length > 0) {
        <span class="ci-chip">
          <span class="ci-chip-label">
            {{
              appliedCompanies.length === 1
                ? appliedCompanies[0]
                : appliedCompanies.length + " companies"
            }}
          </span>
          <button
            type="button"
            class="ci-chip-remove"
            (click)="removeChip('companies')"
            aria-label="Remove company filter"
          >
            ✕
          </button>
        </span>
      }
      @if (appliedStatus) {
        <span class="ci-chip">
          <span class="ci-chip-label">Status: {{ appliedStatus }}</span>
          <button
            type="button"
            class="ci-chip-remove"
            (click)="removeChip('status')"
            aria-label="Remove status filter"
          >
            ✕
          </button>
        </span>
      }
      @if (appliedCategoryType) {
        <span class="ci-chip">
          <span class="ci-chip-label">{{ appliedCategoryType }}</span>
          <button
            type="button"
            class="ci-chip-remove"
            (click)="removeChip('category')"
            aria-label="Remove category filter"
          >
            ✕
          </button>
        </span>
      }
      @if (appliedDatePreset || appliedDateFrom || appliedDateTo) {
        <span class="ci-chip">
          <span class="ci-chip-label">{{ sentDateChipLabel() }}</span>
          <button
            type="button"
            class="ci-chip-remove"
            (click)="removeChip('date')"
            aria-label="Remove date filter"
          >
            ✕
          </button>
        </span>
      }
    </div>
  }

  <!-- ── Loading ─────────────────────────────────────────────────────── -->
  @if (loading()) {
    <div class="ci-state-panel" role="status">
      <svg
        class="ci-spinner"
        width="22"
        height="22"
        viewBox="0 0 24 24"
        fill="none"
        stroke="#1976d2"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        aria-hidden="true"
      >
        <path d="M21 12a9 9 0 1 1-6.219-8.56" />
      </svg>
      <span>Loading inbox…</span>
    </div>
  }

  <!-- ── Error ───────────────────────────────────────────────────────── -->
  @if (!loading() && error()) {
    <div class="ci-state-panel ci-state-panel--error" role="alert">
      <svg
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        aria-hidden="true"
      >
        <circle cx="12" cy="12" r="10" />
        <line x1="12" y1="8" x2="12" y2="12" />
        <circle cx="12" cy="16" r="0.5" fill="currentColor" />
      </svg>
      <span>{{ error() }}</span>
    </div>
  }

  <!-- ── Table ───────────────────────────────────────────────────────── -->
  @if (!loading() && !error()) {
    <div
      class="ci-table-container"
      role="region"
      aria-label="Contract inbox table"
      tabindex="0"
    >
      <table class="ci-table">
        <caption class="ci-visually-hidden">
          Contract notification inbox list
        </caption>

        <thead>
          <tr class="ci-thead-row">
            <!-- Contract Name -->
            <th
              class="ci-th ci-th--sortable ci-col-contract"
              scope="col"
              (click)="sort('contract_name')"
              [attr.aria-sort]="ariaSort('contract_name')"
            >
              Contract Name
              <span class="ci-sort-icon">{{ sortIcon("contract_name") }}</span>
            </th>

            <!-- Company Name -->
            <th
              class="ci-th ci-th--sortable ci-col-company"
              scope="col"
              (click)="sort('company_name')"
              [attr.aria-sort]="ariaSort('company_name')"
            >
              Company Name
              <span class="ci-sort-icon">{{ sortIcon("company_name") }}</span>
            </th>

            <!-- Category Type -->
            <th
              class="ci-th ci-th--sortable ci-col-category"
              scope="col"
              (click)="sort('category_type')"
              [attr.aria-sort]="ariaSort('category_type')"
            >
              Category Type
              <span class="ci-sort-icon">{{ sortIcon("category_type") }}</span>
            </th>

            <!-- Subject -->
            <th
              class="ci-th ci-th--sortable ci-col-subject"
              scope="col"
              (click)="sort('subject')"
              [attr.aria-sort]="ariaSort('subject')"
            >
              Subject
              <span class="ci-sort-icon">{{ sortIcon("subject") }}</span>
            </th>

            <!-- Sender -->
            <th
              class="ci-th ci-th--sortable ci-col-sender"
              scope="col"
              (click)="sort('sender')"
              [attr.aria-sort]="ariaSort('sender')"
            >
              Sender
              <span class="ci-sort-icon">{{ sortIcon("sender") }}</span>
            </th>

            <!-- Recipients -->
            <th class="ci-th ci-col-recipients" scope="col">Recipients</th>

            <!-- CC -->
            <th class="ci-th ci-col-cc" scope="col">CC</th>

            <!-- Sent At -->
            <th
              class="ci-th ci-th--sortable ci-col-sent"
              scope="col"
              (click)="sort('sent_at')"
              [attr.aria-sort]="ariaSort('sent_at')"
            >
              Sent At
              <span class="ci-sort-icon">{{ sortIcon("sent_at") }}</span>
            </th>

            <!-- Expiry Date -->
            <th
              class="ci-th ci-th--sortable ci-col-expiry"
              scope="col"
              (click)="sort('expiry_date')"
              [attr.aria-sort]="ariaSort('expiry_date')"
            >
              Expiry Date
              <span class="ci-sort-icon">{{ sortIcon("expiry_date") }}</span>
            </th>

            <!-- Renewal Date -->
            <th
              class="ci-th ci-th--sortable ci-col-renewal"
              scope="col"
              (click)="sort('renewal_date')"
              [attr.aria-sort]="ariaSort('renewal_date')"
            >
              Renewal Date
              <span class="ci-sort-icon">{{ sortIcon("renewal_date") }}</span>
            </th>

            <!-- Auto Renewal -->
            <th
              class="ci-th ci-th--sortable ci-col-autorenewal ci-th--center"
              scope="col"
              (click)="sort('is_auto_renewal')"
              [attr.aria-sort]="ariaSort('is_auto_renewal')"
            >
              Auto Renewal
              <span class="ci-sort-icon">{{
                sortIcon("is_auto_renewal")
              }}</span>
            </th>

            <!-- Contract Status -->
            <th
              class="ci-th ci-th--sortable ci-col-status ci-th--center"
              scope="col"
              (click)="sort('status')"
              [attr.aria-sort]="ariaSort('status')"
            >
              Contract Status
              <span class="ci-sort-icon">{{ sortIcon("status") }}</span>
            </th>

            <!-- Actions -->
            <th class="ci-th ci-col-actions ci-th--center" scope="col">
              Actions
            </th>
          </tr>
        </thead>

        <tbody>
          @if (sortedRows().length === 0) {
            <tr>
              <td colspan="17" class="ci-empty-cell">
                <div class="ci-empty-state">
                  <svg
                    width="32"
                    height="32"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#b0b8c9"
                    stroke-width="1.5"
                    aria-hidden="true"
                  >
                    <path
                      d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"
                    />
                    <polyline points="22,6 12,13 2,6" />
                  </svg>
                  <span>No notifications found</span>
                </div>
              </td>
            </tr>
          }

          @for (row of sortedRows(); track row.id) {
            <tr
              class="ci-row"
              [class.ci-row--failed]="
                row.status === 'Failed' || row.status === 'failed'
              "
            >
              <!-- Contract Name -->
              <td class="ci-td ci-col-contract">
                <button
                  type="button"
                  class="ci-subject-link"
                  [title]="row.contract_name"
                  (click)="openMailPreview(row)"
                  [attr.aria-label]="'View email for: ' + row.contract_name"
                >
                  <svg
                    width="13"
                    height="13"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="ci-subject-icon"
                    aria-hidden="true"
                  >
                    <path
                      d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"
                    />
                    <polyline points="22,6 12,13 2,6" />
                  </svg>
                  {{ truncate(row.contract_name, 40) }}
                </button>
              </td>

              <!-- Company Name -->
              <td class="ci-td ci-col-company">
                <span class="ci-company-name">{{ row.company_name }}</span>
              </td>

              <!-- Category Type -->
              <td class="ci-td ci-col-category">
                <span class="ci-category-text" [title]="row.category_type">
                  {{ row.category_type || "-" }}
                </span>
              </td>

              <!-- Subject -->
              <td class="ci-td ci-col-subject">
                <span class="ci-summary-text" [title]="row.subject">
                  {{ truncate(row.subject, 45) || "-" }}
                </span>
              </td>

              <!-- Sender -->
              <td class="ci-td ci-col-sender">
                <span class="ci-sender-text">{{ row.sender || "-" }}</span>
              </td>

              <!-- Recipients -->
              <td class="ci-td ci-col-recipients">
                <div class="ci-recipients-cell">
                  @if (row.recipients.length) {
                    <span class="ci-recipient-text" [title]="row.recipients[0]">
                      {{ row.recipients[0] }}
                    </span>
                    @if (row.recipients.length > 1) {
                      <span class="ci-recipient-more"
                        >+{{ row.recipients.length - 1 }} more</span
                      >
                    }
                  } @else {
                    <span class="ci-muted">—</span>
                  }
                </div>
              </td>

              <!-- CC -->
              <td class="ci-td ci-col-cc">
                <div class="ci-recipients-cell">
                  @if (row.cc.length) {
                    <span class="ci-recipient-text" [title]="row.cc[0]">
                      {{ row.cc[0] }}
                    </span>
                    @if (row.cc.length > 1) {
                      <span class="ci-recipient-more"
                        >+{{ row.cc.length - 1 }} more</span
                      >
                    }
                  } @else {
                    <span class="ci-muted">—</span>
                  }
                </div>
              </td>

              <!-- Sent At -->
              <td class="ci-td ci-col-sent ci-date-text">
                {{ row.sent_at ? formatDateTime(row.sent_at) : "-" }}
              </td>

              <!-- Expiry Date -->
              <td class="ci-td ci-col-expiry ci-date-text">
                {{ row.expiry_date ? formatDate(row.expiry_date) : "-" }}
              </td>

              <!-- Renewal Date -->
              <td class="ci-td ci-col-renewal ci-date-text">
                {{ row.renewal_date ? formatDate(row.renewal_date) : "-" }}
              </td>

              <!-- Auto Renewal -->
              <td class="ci-td ci-col-autorenewal ci-td--center">
                <span
                  class="ci-renewal-badge"
                  [class.ci-renewal-badge--yes]="row.is_auto_renewal === 'yes'"
                  [class.ci-renewal-badge--no]="row.is_auto_renewal === 'no'"
                >
                  {{
                    row.is_auto_renewal === "yes"
                      ? "Yes"
                      : row.is_auto_renewal === "no"
                        ? "No"
                        : "—"
                  }}
                </span>
              </td>

              <!-- Contract Status -->
              <td class="ci-td ci-col-status ci-td--center">
                <span
                  class="ci-badge"
                  [class.ci-badge--sent]="
                    row.status === 'Sent' || row.status === 'sent'
                  "
                  [class.ci-badge--failed]="
                    row.status === 'Failed' || row.status === 'failed'
                  "
                  [class.ci-badge--pending]="
                    row.status === 'Pending' || row.status === 'pending'
                  "
                >
                  {{ row.status | titlecase }}
                </span>
              </td>

              <!-- Actions -->
              <td class="ci-td ci-col-actions ci-td--center">
                <div class="ci-actions-cell">
                  <button
                    type="button"
                    class="ci-action-btn"
                    [attr.aria-label]="'View email for: ' + row.contract_name"
                    (click)="openMailPreview(row)"
                    title="View Email"
                  >
                    <svg
                      width="15"
                      height="15"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                      <circle cx="12" cy="12" r="3" />
                    </svg>
                  </button>
                </div>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>

    <!-- ── Pagination ─────────────────────────────────────────────────── -->
    <div class="ci-pagination-bar">
      <div class="ci-record-count" aria-live="polite">
        Showing {{ rows().length }} of {{ apiTotal() }} records
      </div>

      <div class="ci-page-size-host">
        <span class="ci-page-size-label" id="ciPageSizeLabel"
          >Rows per page:</span
        >
        <select
          class="ci-select ci-select--sm"
          [(ngModel)]="pageSizeValue"
          (ngModelChange)="onPageSizeChange($event)"
          aria-labelledby="ciPageSizeLabel"
        >
          <option [value]="25">25</option>
          <option [value]="50">50</option>
          <option [value]="75">75</option>
          <option [value]="100">100</option>
        </select>
      </div>

      <nav class="ci-pager" aria-label="Table pagination">
        <span class="ci-page-info"
          >Page {{ currentPage() }} of {{ totalPages() }}</span
        >
        <button
          class="ci-pager-btn"
          type="button"
          [disabled]="currentPage() === 1"
          (click)="goToPage(1)"
          aria-label="Go to first page"
        >
          Previous
        </button>
        <button
          class="ci-pager-btn"
          type="button"
          [disabled]="currentPage() === 1"
          (click)="goToPage(currentPage() - 1)"
          aria-label="Go to previous page"
        >
          ‹
        </button>
        @for (p of visiblePages(); track $index) {
          <button
            [class]="getPagerBtnClass(p)"
            type="button"
            [disabled]="p === -1"
            [attr.aria-current]="p === currentPage() ? 'page' : null"
            (click)="p !== -1 && goToPage(p)"
          >
            {{ p === -1 ? "…" : p }}
          </button>
        }
        <button
          class="ci-pager-btn"
          type="button"
          [disabled]="currentPage() === totalPages()"
          (click)="goToPage(currentPage() + 1)"
          aria-label="Go to next page"
        >
          ›
        </button>
        <button
          class="ci-pager-btn"
          type="button"
          [disabled]="currentPage() === totalPages()"
          (click)="goToPage(totalPages())"
          aria-label="Go to last page"
        >
          Next
        </button>
      </nav>
    </div>
  }
</div>
<!-- /ci-wrapper -->

<!-- ══════════════════════════════════════════════════════════════════════
       M A I L   P R E V I E W   M O D A L
  ══════════════════════════════════════════════════════════════════════ -->
@if (previewRow) {
  <div
    class="ci-modal-backdrop"
    role="presentation"
    (click)="closeMailPreview()"
  ></div>

  <div
    class="ci-modal-dialog"
    [class.ci-modal-dialog--fullscreen]="modalFullscreen"
    role="dialog"
    aria-modal="true"
    aria-labelledby="ci-modal-title"
  >
    <!-- Header -->
    <div class="ci-modal-header">
      <div class="ci-modal-header-left">
        <svg
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#1976d2"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="ci-modal-header-icon"
          aria-hidden="true"
        >
          <path
            d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"
          />
          <polyline points="22,6 12,13 2,6" />
        </svg>
        <h4 class="ci-modal-title" id="ci-modal-title">Email Preview</h4>
      </div>
      <div class="ci-modal-header-actions">
        <button
          type="button"
          class="ci-modal-icon-btn"
          [attr.aria-label]="
            modalFullscreen ? 'Exit fullscreen' : 'Enter fullscreen'
          "
          (click)="modalFullscreen = !modalFullscreen"
        >
          @if (modalFullscreen) {
            <svg
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <polyline points="4 14 10 14 10 20" />
              <polyline points="20 10 14 10 14 4" />
              <line x1="10" y1="14" x2="3" y2="21" />
              <line x1="21" y1="3" x2="14" y2="10" />
            </svg>
          } @else {
            <svg
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <polyline points="15 3 21 3 21 9" />
              <polyline points="9 21 3 21 3 15" />
              <line x1="21" y1="3" x2="14" y2="10" />
              <line x1="3" y1="21" x2="10" y2="14" />
            </svg>
          }
        </button>
        <button
          type="button"
          class="ci-modal-icon-btn ci-modal-icon-btn--close"
          aria-label="Close email preview"
          (click)="closeMailPreview()"
        >
          <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>
      </div>
    </div>

    <!-- Mail Metadata -->
    <div class="ci-mail-meta">
      @if (mailDetailLoading()) {
        <div class="ci-mail-meta-loading" role="status">
          <svg
            class="ci-spinner"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#1976d2"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            aria-hidden="true"
          >
            <path d="M21 12a9 9 0 1 1-6.219-8.56" />
          </svg>
          <span>Loading email…</span>
        </div>
      } @else if (mailDetailError()) {
        <div class="ci-mail-meta-error" role="alert">
          <svg
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            aria-hidden="true"
          >
            <circle cx="12" cy="12" r="10" />
            <line x1="12" y1="8" x2="12" y2="12" />
            <circle cx="12" cy="16" r="0.5" fill="currentColor" />
          </svg>
          <span>{{ mailDetailError() }}</span>
        </div>
      } @else if (mailDetail()) {
        <!-- ✅ FIX: table wrapper is here, rows are inside tbody -->
        <table class="ci-mail-fields">
          <tbody>
            <tr>
              <th class="ci-mail-field-label">Subject</th>
              <td class="ci-mail-field-value ci-mail-subject-value">
                {{ mailDetail()!.subject }}
              </td>
            </tr>
            <tr>
              <th class="ci-mail-field-label">From</th>
              <td class="ci-mail-field-value">{{ mailDetail()!.sender }}</td>
            </tr>
            <tr>
              <th class="ci-mail-field-label">To</th>
              <td class="ci-mail-field-value">
                <div class="ci-mail-recipients-list">
                  @for (r of mailDetail()!.recipients; track r) {
                    <span class="ci-recipient-pill">{{ r }}</span>
                  }
                  @if (mailDetail()!.recipients.length === 0) {
                    <span class="ci-muted">—</span>
                  }
                </div>
              </td>
            </tr>
            @if (mailDetail()!.cc.length) {
              <tr>
                <th class="ci-mail-field-label">CC</th>
                <td class="ci-mail-field-value">
                  <div class="ci-mail-recipients-list">
                    @for (r of mailDetail()!.cc; track r) {
                      <span class="ci-recipient-pill">{{ r }}</span>
                    }
                  </div>
                </td>
              </tr>
            }
            @if (mailDetail()!.bcc.length) {
              <tr>
                <th class="ci-mail-field-label">BCC</th>
                <td class="ci-mail-field-value">
                  <div class="ci-mail-recipients-list">
                    @for (r of mailDetail()!.bcc; track r) {
                      <span class="ci-recipient-pill">{{ r }}</span>
                    }
                  </div>
                </td>
              </tr>
            }
            <tr>
              <th class="ci-mail-field-label">Sent</th>
              <td class="ci-mail-field-value">
                {{ formatDateTime(mailDetail()!.sent_at) }}
              </td>
            </tr>
            <!-- <tr>
              <th class="ci-mail-field-label">Category</th>
              <td class="ci-mail-field-value">{{ mailDetail()!.category || '—' }}</td>
            </tr> -->
            <!-- <tr>
              <th class="ci-mail-field-label">Company</th>
              <td class="ci-mail-field-value">{{ mailDetail()!.company || '—' }}</td>
            </tr> -->
            <tr>
              <th class="ci-mail-field-label">Status</th>
              <td class="ci-mail-field-value">
                <span
                  class="ci-badge"
                  [class.ci-badge--sent]="
                    mailDetail()!.status === 'Sent' ||
                    mailDetail()!.status === 'sent'
                  "
                  [class.ci-badge--failed]="
                    mailDetail()!.status === 'Failed' ||
                    mailDetail()!.status === 'failed'
                  "
                  [class.ci-badge--pending]="
                    mailDetail()!.status === 'Pending' ||
                    mailDetail()!.status === 'pending'
                  "
                >
                  {{ mailDetail()!.status | titlecase }}
                </span>
                @if (mailDetail()!.error) {
                  <span class="ci-mail-error-text">{{
                    mailDetail()!.error
                  }}</span>
                }
              </td>
            </tr>
          </tbody>
        </table>
      }
    </div>

    <!-- Divider -->
    <div class="ci-mail-body-divider">
      <span>Email Body</span>
    </div>

    <!-- Mail Body -->
    <div class="ci-modal-body">
      @if (mailDetailLoading()) {
        <div class="ci-skeleton-wrap">
          @for (_ of [1, 2, 3, 4, 5]; track $index) {
            <div
              class="ci-skeleton-line"
              [style.width]="
                $index % 3 === 0 ? '65%' : $index % 2 === 0 ? '85%' : '100%'
              "
            ></div>
          }
        </div>
      } @else if (mailDetail()?.message) {
        <div class="ci-mail-body-html" [innerHTML]="sanitizedBody()"></div>
      } @else if (!mailDetailLoading() && !mailDetailError()) {
        <div class="ci-modal-empty">
          <svg
            width="28"
            height="28"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#c8d0dc"
            stroke-width="1.5"
            aria-hidden="true"
          >
            <path
              d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"
            />
            <polyline points="22,6 12,13 2,6" />
          </svg>
          <span>No email content available.</span>
        </div>
      }
    </div>
  </div>
}
